import { getAxiosConfig } from "@/services/axiosConfig";
import { IBrandsGeneric, IProductDataGeneric } from "global-types/global.types";
import { useQuery } from "react-query";

interface Data<T> {
  data: T;
}

export default function useNewProductsAccordingHome() {
  const { data: productsNewHome, isLoading: isLoadingProductsNewHome } =
    useQuery(["PDOUCTS_NEW_HOME"], async () => {
      const res = await getAxiosConfig().get<
        Data<IProductDataGeneric<IBrandsGeneric>[]>
      >(`/home/new`);

      return res.data;
    });

  return { productsNewHome, isLoadingProductsNewHome };
}
